import './global-shim';
import '@angular/localize/init';
import 'core-js';
import 'zone.js';  // Included with Angular CLI.
import 'intl'; 
import 'intl/locale-data/complete.js';
import 'intl/locale-data/jsonp/en.js';

(window as any).process = {
  env: {
    NODE_ENV: 'development',  // or 'production' if you're building for prod
    NODE_DEBUG: false
  }
};

(window as any).global = window;
global.Buffer = global.Buffer || require('buffer').Buffer;
global.process = require('process');

if (typeof SVGElement.prototype.contains == 'undefined') {
	SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
}